import React, {useEffect} from "react";
 
import { useHistory } from "react-router-dom";
import URLS from "../../../config/navigation";
import CircularProgress from "@material-ui/core/CircularProgress";
import {useDispatch} from "react-redux";
import queryString from "query-string";
import {accountVerification} from "../../../store/entities/Auth/Auth.actions";
import HelmetComponent from "../../../components/Common/Helmet";
import TitleComponent from "../../../components/Auth/TitleContainer";
const ActivateAccount = (props) => {
  
  const history = useHistory();
  const dispatch = useDispatch();

  const callback = () => {
    history.push(URLS.PROFILE.DATA);
  }

  useEffect(() => {
    const { code } = queryString.parse(props.location.search);
    dispatch(accountVerification({ code, callback }));
  }, [])

  return (
    <div className={"statusContainer"}>
      <CircularProgress />
      <HelmetComponent title="Active your account - TeachOn"/>
      <TitleComponent title={"Active your account"} />
      
      <h2>Please wait! Thank you!</h2>
    </div>
  );
}

export default ActivateAccount;
